import { useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Box, styled, Typography } from "@mui/material";
import { AlertMessage, Spinner , OrderHistoryList, ReservationHistoryList} from '../components';
import { useSelector } from "react-redux";
import { InvoicePayCard } from "../components/HomePageContent/invoicePayCard";
import { useUserInfoContext } from '../contexts';
import { TypographyP1 } from "../assets/typographyTheme";
import Banner_Strand from "../assets/images/Banner_Strand.png";

const BannerContainer = styled('div')(
    ({ aboveFoldBGImage, theme: { palette: { primary }, breakpoints }}) => `
    background-color: ${primary.main};
    background-image: url(${aboveFoldBGImage});
    background-size: cover;
    height: 200px;
    width: 100%;
    border-radius: 16px;
    ${[breakpoints.down('sm')]} {
        background-image: unset;
    }
    `
);

const OrderHistoryPage = () => {
  const userData = useSelector((store) => store?.commerce?.userData);
  const user = useSelector((store) => store?.commerce?.userInfo?.user);
  const oktaID = userData?.authenticatedId || user?.authenticatedId;
  const userId = userData?.userId;
  const [errorMsg, setErrorMsg] = useState('');
  const alertRef = useRef(null);
  const { globalErrorMessage = [] } = useSelector(store => store?.globalMessages);
  const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data) => data?.fields?.code === "GENERAL_API_ERROR");
  const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
  const [processing, setProcessing] = useState(false);

   const errorMsgHandler = (errorMsg) => {
      let errMsg = errorMsg ? errorMsg : generalApiError;
      setErrorMsg(errMsg);
      alertRef.current?.openAlert(errorMsg);
   }
   
  return (
    <>
      <AlertMessage variant={"filled"} type={"error"} message={errorMsg} sx={{ top: 120 }} ref={alertRef} />
      <Spinner processing={processing} />
      <Box padding='48px' display='flex' flexDirection='row' gap={2}>
        <BannerContainer aboveFoldBGImage={Banner_Strand}>
          <Typography variant={'h1'} color={'neutral.white'} py={'40px'} px={{xs:'32px', lg:'100px'}}>Order History</Typography>
        </BannerContainer>
        <InvoicePayCard />
      </Box>
      <ReservationHistoryList userId={oktaID} handleErrorMsg={errorMsgHandler}/>
      <OrderHistoryList userId={userId} handleErrorMsg={errorMsgHandler} setLoading={setProcessing}/>
    </>
  );
};

export default OrderHistoryPage;
